import React from 'react';
import * as PropTypes from 'prop-types';
import { Svg, CircleBase, CircleProgress } from './elements';

function ProB05(props) {
  const percentage = props.percent < 0 ? 0 : props.percent;
  // radius as per spec - 86
  const circumference = 2 * Math.PI * 86;
  const arc = (circumference * (100 - percentage)) / 100;
  // color for POINTS and default

  return (
    <div className={props.className}>
      <Svg>
        <CircleBase cx="90px" cy="90px" r="86px" />
        <CircleProgress
          cx="90px"
          cy="90px"
          r="86px"
          stroke={props.color || '#8bc34a'}
          strokeDasharray={circumference}
          strokeDashoffset={arc}
          transform={'rotate(-90, 90, 90)'}
        />
      </Svg>
    </div>
  );
}

ProB05.propTypes = {
  className: PropTypes.string,
  percent: PropTypes.number,
  color: PropTypes.string,
};

export default ProB05;
